import LOGO from '../../assets/LOGO (2).png';

export const AuthHeader = ({ title, subtitle }) => (
  <div className="text-center mb-4 mt-52">
    <img src={LOGO} alt="Easy Survey" className="h-16 mx-auto mb-6" />
    <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
    {subtitle && <p className="text-gray-600 text-lg">{subtitle}</p>}
  </div>
);
